function randomFromInterval(min, max) {
  return Math.random() * (max - min) + min;
}

// Generate cat nose (small, triangular - cartoon style)
export function generateCatNose(snoutBottomY, snoutLength, headScale = 1) {
  // Cat nose is small and triangular (inverted triangle)
  let noseWidth = randomFromInterval(10, 18) * headScale;
  let noseHeight = randomFromInterval(7, 13) * headScale;

  // Position nose higher on the snout for cartoon style
  let noseY = snoutBottomY - noseHeight * 0.5;

  // Inverted triangle cat nose shape (wider at top)
  let nosePoints = [
    [-noseWidth / 2, noseY - noseHeight * 0.6],  // Top left
    [noseWidth / 2, noseY - noseHeight * 0.6],   // Top right
    [noseWidth * 0.3, noseY - noseHeight * 0.2],
    [0, noseY + noseHeight * 0.4],  // Bottom point (tip)
    [-noseWidth * 0.3, noseY - noseHeight * 0.2],
    [-noseWidth / 2, noseY - noseHeight * 0.6]
  ];

  // Nostrils (small slits for cats)
  let leftNostril = {
    x: -noseWidth / 4,
    y: noseY - noseHeight * 0.3
  };

  let rightNostril = {
    x: noseWidth / 4,
    y: noseY - noseHeight * 0.3
  };

  // Calculate actual nose bottom Y position
  let noseBottomY = noseY + noseHeight * 0.3;

  return {
    outline: nosePoints,
    leftNostril: leftNostril,
    rightNostril: rightNostril,
    noseBottomY: noseBottomY
  };
}
